<template>
    <div id="vehicle_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleHeader" v-if="$route.params.id > 0">Update Asset Feature</span>
                    <span class="page-title" id="vehicleHeader" v-else>Add Asset Feature</span>
                    <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VehicleFeatureForm">
                                <div class="col-md-12">
                                    <div class="row">
                                        <h3 class="vendor-title"> General Information</h3>
                                        <div class="form-group">
                                            <div class="col-sm-4">
                                                <!-- <div class="form-group"> -->
                                                <label class="control-label" for="stockno">Stock No:</label>
                                                <!-- <div class="col-sm-12"> -->
                                                <input type="text" class="form-control" v-model="stock_no" id="stockno" placeholder="Enter Stock No" name="stock_no">
                                                <div class="c-error">{{stock_no_error_msg}}</div>
                                                <!-- </div> -->
                                                <!-- </div> -->
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" >Condition:</label>
                                                <v-select v-model="new_used" name="new_used" placeholder="Select Condition."
                                                            label="text"
                                                            :options="conditionArr">
                                                </v-select>
                                                <div class="c-error">{{new_used_error_msg}}</div>
                                            </div>
                                            <!--<div class="col-sm-4">
                                                <label class="control-label" for="odometer_device">Milege :</label>
                                                <input type="text" class="form-control" v-model="odometer_device" id="odometer_device" placeholder="Enter Milege" name="odometer_device">
                                                <div class="c-error">{{odometer_device_error_msg}}</div>
                                            </div>-->
                                            <div class="col-sm-4">
                                                <label class="control-label" for="body_length">Body Length :</label>
                                                <input type="text" class="form-control" v-model="body_length" id="body_length" placeholder="Enter Length" name="body_length">
                                                <div class="c-error">{{body_length_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" for="body_length">State Dot:</label>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="dot1">
                                                        Yes
                                                        <input type="radio" v-model="dot" :value="1" id="dot1" name="dot">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="dot2">
                                                        No
                                                        <input type="radio" v-model="dot" :value="0" id="dot2" name="dot" >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <!--<div class="col-sm-4">
                                                <label class="control-label" for="body_length">Sale Price :</label>
                                                <input type="text" class="form-control" v-model="sale_price" id="sale_price" placeholder="Enter Price for sale" name="sale_price">
                                                <div class="c-error">{{sale_price_error_msg}}</div>
                                            </div>

                                            -->
                                        </div>
                                        <div class="clearfix"></div>

                                        <h3> Engine </h3>

                                        <div class="form-group">
                                            <div class="col-sm-4">
                                                <label class="control-label" >Engine Manufacturer:</label>
                                                <v-select v-model="engine_manufacturer" name="engine_manufacturer" placeholder="Select Manufacturer."
                                                            label="text"
                                                            :options="engineArr">
                                                </v-select>
                                                <div class="c-error">{{engine_manufacturer_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" for="engine_model">Engine Model :</label>
                                                <input type="text" class="form-control" v-model="engine_model" id="engine_model" placeholder="Enter Engine Model" name="engine_model">
                                                <div class="c-error">{{engine_model_error_msg}}</div>
                                            </div>
                                                <div class="col-sm-4">
                                                    <label class="control-label" for="horsepower">Engine Size :</label>
                                                    <input type="number" class="form-control" v-model="engine_size" id="engine_size" placeholder="Enter Engine Size" name="engine_size">
                                                    <div class="c-error">{{engine_size_error_msg}}</div>
                                                </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="horsepower">Horsepower :</label>
                                                <input type="text" class="form-control" v-model="horsepower" id="horsepower" placeholder="Enter Horsepower" name="horsepower">
                                                <div class="c-error">{{horsepower_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" >Fuel type:</label>
                                                <v-select v-model="fuel_type" name="fuel_type" placeholder="Select Fuel Type."
                                                            label="text"
                                                            :options="fuelTypeArr">
                                                </v-select>
                                                <div class="c-error">{{fuel_type_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="body_length">Engine Overhaul:</label>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="overhaul1">
                                                        Yes
                                                        <input type="radio" v-model="overhaul" :value="1" id="overhaul1" name="overhaul">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="overhaul2">
                                                        No
                                                        <input type="radio" v-model="overhaul" :value="0" id="overhaul2" name="overhaul" >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="body_length">Engine Brake:</label>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="engine_brake1">
                                                        Yes
                                                        <input type="radio" v-model="engine_brake" :value="1" id="engine_brake1" name="engine_brake">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="engine_brake2">
                                                        No
                                                        <input type="radio" v-model="engine_brake" :value="0" id="engine_brake2" name="engine_brake" >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="clearfix"></div>

                                        <h3> Powertrain </h3>

                                        <div class="form-group">
                                            <div class="col-sm-4">
                                                <label class="control-label" >Transmission:</label>
                                                <v-select v-model="transmission" name="transmission" placeholder="Select Transmission."
                                                            label="text"
                                                            :options="transArr">
                                                </v-select>
                                                <div class="c-error">{{transmission_error_msg}}</div>
                                            </div>

                                            <div class="col-sm-4">
                                                <label class="control-label" >Transmission Manufaturer:</label>
                                                <v-select v-model="trans_manufacturer" name="trans_manufacturer " placeholder="Select Manufacturer."
                                                            label="text"
                                                            :options="transManufacturerArr">
                                                </v-select>
                                                <div class="c-error">{{trans_manufacturer_error_msg}}</div>
                                            </div>

                                            <div class="col-sm-4">
                                                <label class="control-label" >Transmission Model:</label>
                                                <v-select v-model="trans_model" name="trans_model " placeholder="Select Model."
                                                            label="text"
                                                            :options="transModelArr">
                                                </v-select>
                                                <div class="c-error">{{trans_model_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" >Transmission Speed:</label>
                                                <v-select v-model="trans_speed" name="numspeeds" placeholder="Select Speed."
                                                            label="text"
                                                            :options="numspeedArr">
                                                </v-select>
                                                <div class="c-error">{{trans_speed_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="horsepower">Ratio :</label>
                                                <input type="number" class="form-control" v-model="ratio" id="ratio" placeholder="Enter Ratio" name="ratio">
                                                <div class="c-error">{{ratio_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="body_length">Overdrive:</label>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="overdrive1">
                                                        Yes
                                                        <input type="radio" v-model="overdrive" :value="1" id="overdrive1" name="overdrive">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="overdrive2">
                                                        No
                                                        <input type="radio" v-model="overdrive" :value="0" id="overdrive2" name="overdrive" >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <label class="control-label" for="body_length">Diffrential Lock:</label>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="differential_lock1">
                                                        Yes
                                                        <input type="radio" v-model="differential_lock" :value="1" id="differential_lock1" name="differential_lock">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <label class="boolean optional radio-custom" for="differential_lock2">
                                                        No
                                                        <input type="radio" v-model="differential_lock" :value="0" id="differential_lock2" name="differential_lock" >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="clearfix"></div>

                                        <h3> Chasis </h3>
                                        <div class="form-group">
                                            <div class="col-sm-4">
                                                <label class="control-label" >Wheel Type:</label>
                                                <v-select v-model="wheelbase" name="wheelbase" placeholder="Select WheelBase."
                                                            label="text"
                                                            :options="wheelBaseArr">
                                                </v-select>
                                                <div class="c-error">{{wheelbase_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" for="f_axle_wgt">Front Axle Weight :</label>
                                                <input type="text" class="form-control" v-model="f_axle_wgt" id="f_axle_wgt" placeholder="Front axle Weight" name="f_axle_wgt">
                                                <div class="c-error">{{f_axle_wgt_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" for="f_axle_wgt">Rear Axle Weight :</label>
                                                <input type="text" class="form-control" v-model="r_axle_wgt" id="r_axle_wgt" placeholder="Rear axle Weight" name="r_axle_wgt">
                                                <div class="c-error">{{r_axle_wgt_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="control-label" >Suspention:</label>
                                                <v-select v-model="susp_make" name="susp_make" placeholder="Select Suspention."
                                                            label="text"
                                                            :options="suspArr">
                                                </v-select>
                                                <div class="c-error">{{susp_make_error_msg}}</div>
                                            </div>
                                        </div>

                                        <div class="clearfix"></div>

                                        <h3> Interior </h3>

                                        <div class="form-group">

                                            <div class="col-sm-4">
                                                <label class="control-label" >Sleeper:</label>
                                                <v-select v-model="sleeper_type" name="sleeper_type" placeholder="Select Sleeper Type."
                                                            label="text"
                                                            :options="sleeperTypeArr">
                                                </v-select>
                                                <div class="c-error">{{sleeper_type_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="control-label" for="sleeper_size">Sleeper Size :</label>
                                                <input type="text" class="form-control" v-model="sleeper_size" id="sleeper_size" placeholder="Enter Size" name="sleeper_size">
                                                <div class="c-error">{{sleeper_size_error_msg}}</div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="form-group">
                                            <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>

                                        <div class="clearfix"></div>

                                        <div class="col-xs-12 btm-action-btn-fl">
                                            <div class="row">

                                                <button type="submit" id="createVehicleBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateVehicleFeature">
                                                    <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                                </button>

                                                <!-- <button type="submit" id="createVehicleBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateVehicle" >
                                                    <i class="hi-icon icon-flSave"> </i>  Save
                                                </button>

                                                <button type="submit" id="createAndContinueVehicleBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateVehicle(flag='Save and Continue')" >
                                                    <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                                </button>-->

                                                <button type="submit" id="cancelVehicleBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackVehicleList" >
                                                    <i class="hi-icon icon-flCancel"> </i>  Cancel
                                                </button>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";

    import {commonMixins} from '../mixins/commonMixins';





    export default {
        name: "VehicleBasicFeatureCreate",
        mixins:[commonMixins],
        data: () => ({
            isEdit:false,
            permissions: [],
            fuelTypeArr:[],
            cantAccessPage: "",
            loading:false,
            stock_no:"",
            new_used:null,
            conditionArr:[{text:'New' , value:'New'},{text:'Used' , value:'Used'}],
//            odometer_device:"",
            body_length:"",
            sale_price:"",
            dot:0,
            engine_manufacturer:null,
            engine_model:"",
            horsepower:"",
            trans_manufacturer:null,
            trans_model:null,
            trans_speed:null,
            sleeper_type:null,
            sleeper_size:"",
            wheelbase:null,
            f_axle_wgt:"",
            r_axle_wgt:"",
            susp_make:null,
            overhaul:0,
            engine_brake:1,
            engine_size:0,
            fuel_type:null,
            transmission:null,
            transmission_type:"",
            overdrive:0,
            ratio:0,
            differential_lock:1,
//            numspeeds:"",
            stock_no_error_msg:"",
            sleeper_size_error_msg:"",
            new_used_error_msg:"",
//            odometer_device_error_msg:"",
            body_length_error_msg:"",
            sale_price_error_msg:"",
            dot_error_msg:"",
            engine_manufacturer_error_msg:"",
            engine_model_error_msg:"",
            horsepower_error_msg:"",
            trans_manufacturer_error_msg:"",
            trans_model_error_msg:"",
            trans_speed_error_msg:"",
            sleeper_type_error_msg:"",
            wheelbase_error_msg:"",
            f_axle_wgt_error_msg:"",
            r_axle_wgt_error_msg:"",
            susp_make_error_msg:"",
            engine_brake_error_msg:"",
            engine_size_error_msg:"",
            fuel_type_error_msg:"",
            transmission_error_msg:"",
            transmission_type_error_msg:"",
            overdrive_error_msg:"",
            ratio_error_msg:"",
            differential_lock_error_msg:"",
            extraFeature:"",
            renderComponent: false,
            featureLines:[],
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_asset') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }
        },
        mounted: function() {
            var self = this;
            this.getPermissions();

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.loadVehicle();
//                self.renderComponent=true;
            }else{
                self.renderComponent=true;
            }
            self.getFuelType();
//            store.state.lines=[];
        },
        methods: {
           BackVehicleList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.$router.push({name: 'AssetView',params:{id:segments[3],selectTab:4}});
//                self.$router.push("/asset/list");
            },

            CreateVehicleFeature(){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");
                var error = false;


                if (!error) {
                    self.loading = true;

                    if (segments[3])
                    {
                        $("#createVehicleBtn").val("Updating ...");
                        $("#createVehicleBtn").prop("disabled", true);
                        $("#cancelVehicleBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleBtn").val("Saving ...");
                            $("#createVehicleBtn").prop("disabled", true);
                            $("#createAndContinueVehicleBtn").prop("disabled", true);
                            $("#cancelVehicleBtn").prop("disabled",true);

                        }else{

                            $("#createVehicleBtn").val("Saving ...");
                            $("#createVehicleBtn").prop("disabled", true);
                            $("#createAndContinueVehicleBtn").prop("disabled", true);
                            $("#cancelVehicleBtn").prop("disabled",true);
                        }

                    }


                    var fields = $("#VehicleFeatureForm").serializeArray();
                   /* if(featureLines.length > 0)
                    {
                        fields.push({name:"extra_features",value:JSON.stringify(featureLines)});
                    }else{
                        fields.push({name:"extra_features",value:''});
                    }
*/
                    if (self.new_used == null || self.new_used == "") {
                        fields.push({name: "new_used", value: ""});
                    } else {
                        fields.push({name: "new_used", value: self.new_used.value});
                    }

                    if (self.fuel_type == null || self.fuel_type == "") {
                        fields.push({name: "fuel_type", value: ""});
                    } else {
                        fields.push({name: "fuel_type", value: self.fuel_type.value});
                    }

                    if (self.engine_manufacturer == null || self.engine_manufacturer == "") {
                        fields.push({name: "engine_manufacturer", value: ""});
                    } else {
                        fields.push({name: "engine_manufacturer", value: self.engine_manufacturer.value});
                    }

                    if (self.transmission == null || self.transmission == "") {
                        fields.push({name: "transmission", value: ""});
                    } else {
                        fields.push({name: "transmission", value: self.transmission.value});
                    }

                    if (self.trans_manufacturer == null || self.trans_manufacturer == "") {
                        fields.push({name: "trans_manufacturer", value: ""});
                    } else {
                        fields.push({name: "trans_manufacturer", value: self.trans_manufacturer.value});
                    }

                    if (self.trans_model == null || self.trans_model == "") {
                        fields.push({name: "trans_model", value: ""});
                    } else {
                        fields.push({name: "trans_model", value: self.trans_model.value});
                    }

                    if (self.trans_speed == null || self.trans_speed == "") {
                        fields.push({name: "trans_speed", value: ""});
                    } else {
                        fields.push({name: "trans_speed", value: self.trans_speed.value});
                    }

                    if (self.sleeper_type == null || self.sleeper_type == "") {
                        fields.push({name: "sleeper_type", value: ""});
                    } else {
                        fields.push({name: "sleeper_type", value: self.sleeper_type.value});
                    }
                    if (self.wheelbase == null || self.wheelbase == "") {
                        fields.push({name: "wheelbase", value: ""});
                    } else {
                        fields.push({name: "wheelbase", value: self.wheelbase.value});
                    }
                    if (self.susp_make == null || self.susp_make == "") {
                        fields.push({name: "susp_make", value: ""});
                    } else {
                        fields.push({name: "susp_make", value: self.susp_make.value});
                    }

                    if (self.dot == null) {
                        fields.push({name: "dot", value: null});
                    }
                    if (self.overhaul == null) {
                        fields.push({name: "overhaul", value: null});
                    }
                    if (self.engine_brake == null) {
                        fields.push({name: "engine_brake", value: null});
                    }
                    if (self.overdrive == null) {
                        fields.push({name: "overdrive", value: null});
                    }
                    if (self.differential_lock == null) {
                        fields.push({name: "differential_lock", value: null});
                    }

                    fields.push({name: "id", value: segments[3]});

                    $.ajax({
                        url: process.env.ROOT_API + "/assetFeature/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (segments[3]) {
                                $("#createVehicleBtn").val("Update");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueVehicleBtn").val("Save and Continue");
                                    $("#createVehicleBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleBtn").prop("disabled", false);
                                    $("#cancelVehicleBtn").prop("disabled", false);

                                } else {

                                    $("#createVehicleBtn").val("Save");
                                    $("#createVehicleBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleBtn").prop("disabled", false);
                                    $("#cancelVehicleBtn").prop("disabled", false);

                                }
                            }
                            if (data.status == "success") {
                                self.$router.push({name: 'AssetView', params: {id: segments[3], selectTab: 4}});
                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {

                            self.loading = false;
                            if (segments[3]) {
                                $("#createVehicleBtn").val("Update");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);

                            } else {
                                if (flag == "Save and Continue") {

                                    $("#VehicleForm").trigger("reset");


                                    $("#createAndContinueVehicleBtn").val("Save and Continue");
                                    $("#createVehicleBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleBtn").prop("disabled", false);
                                    $("#cancelVehicleBtn").prop("disabled", false);

                                } else {

                                    $("#createVehicleBtn").val("Save");
                                    $("#createVehicleBtn").prop("disabled", false);
                                    $("#createAndContinueVehicleBtn").prop("disabled", false);
                                    $("#cancelVehicleBtn").prop("disabled", false);

                                }
                            }
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");

                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    });
                }

            },
            getFuelType(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/getFuelType",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.fuelTypeArr = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadVehicle() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {

                            self.isEdit = true;

                            self.stock_no = data.content.stock_no;
                            self.body_length = data.content.body_length;
                            self.engine_model =data.content.engine_model;
                            self.horsepower = data.content.horsepower;
                            self.f_axle_wgt = data.content.f_axle_wgt;
                            self.r_axle_wgt = data.content.r_axle_wgt;
                            self.sleeper_size = data.content.sleeper_size;
                            self.engine_manufacturer = {text:data.content.engine_manufacturer , value:data.content.engine_manufacturer};
                            self.trans_manufacturer = {text:data.content.trans_manufacturer , value:data.content.trans_manufacturer};
                            self.trans_model ={text:data.content.trans_model , value:data.content.trans_model};
                            self.trans_speed = {text:data.content.trans_speed , value:data.content.trans_speed};
                            self.sleeper_type ={text:data.content.sleeper_type , value:data.content.sleeper_type};
                            self.wheelbase =  {text:data.content.wheelbase , value:data.content.wheelbase};
                            self.susp_make = {text:data.content.susp_make , value:data.content.susp_make};
//                            self.fuel_type = {text:data.content.fuel_type , value:data.content.susp_make};
                            self.fuel_type = data.content.fuel_type;
                            self.dot = data.content.dot;
                            self.engine_size = data.content.engine_size;
                            self.overhaul = data.content.overhaul;
                            self.engine_brake = data.content.engine_brake;
                            self.ratio = data.content.ratio;
                            self.overdrive = data.content.overdrive;
                            self.differential_lock = data.content.differential_lock;
                            self.new_used = {text:data.content.new_used , value:data.content.new_used};
                            self.transmission = {text:data.content.transmission , value:data.content.transmission};

//                            self.$nextTick(function(){
                          /*  if(data.content.extra_features!= '' && data.content.extra_features!= null ) {
                                store.state.lines = data.content.extra_features;
                            }else{
                                store.state.lines =[];
                            }*/
                            self.renderComponent = true;

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/AssetBasicFeatureCreate.vue